import { useQuery } from "@tanstack/react-query";
import { GET_DISTRICT_DATA } from "../api/queries";
import { graphQLClient } from "../graphqlClient";

const fetchDistrictById = async ({ queryKey }) => {
  const [, { id }] = queryKey;
  if (!id) throw new Error("District ID is required");

  const { getDistrictById } = await graphQLClient.request(GET_DISTRICT_DATA, {
    id,
  });

  return getDistrictById;
};

export const useGetDistrictById = (id, enabled = true) => {
  return useQuery({
    queryKey: id ? ["districtById", { id }] : null,
    queryFn: fetchDistrictById,
    enabled: enabled && !!id,
  });
};
